import React from 'react'
import { NavLink } from 'react-router-dom'

import DriveFileMoveOutlinedIcon from '@mui/icons-material/DriveFileMoveOutlined'

import emptyDoc from './../../img/development_document.svg'
import Empty from './../_ui/empty'
import css from './disciplines.module.scss'

const Disciplines = (props: any) => {
    return (
        <section className={css.main}>
            <section className={css.mainContainer}>
                <header className={css.header}>
                    <h4>Дисциплины по направлению {props.disciplinesList[0]?.specialty_code_name}</h4>
                </header>

                <section className={css.container}>
                    {!props.disciplinesList.length
                        ? <Empty image={emptyDoc} description="" />
                        : props.disciplinesList.map((item: any) => {
                            return (
                                <NavLink to={`${item.discipline_id}`} key={item.discipline_id} className={css.tRow}>
                                    <DriveFileMoveOutlinedIcon  />
                                    <div>{item.discipline_name}</div>
                                </NavLink>
                            )
                        })
                    }
                </section>
            </section>
        </section>
    )
}

export default Disciplines